import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-productsearch',
  templateUrl: './productsearch.component.html',
  styleUrls: ['./productsearch.component.css']
})
export class ProductsearchComponent implements OnInit {


  @Input() productColl: any = []

  searchtxt :any=""
  
  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private activeModal: NgbActiveModal) {
  
  }

  
  ngOnInit() {
   

  }

  fnVariationBtnClick() {
   
  }
 
  public cartClick() {

    this.emitData.emit("CART");
    this.activeModal.close(false);

  }

  public decline() {


    this.activeModal.close(false);
  }


}
